export function shareOffer() {
    const shareBtn = document.querySelectorAll('.share-button');

    shareBtn.forEach(element => {
        element.addEventListener("click", e => {
            let currentLink = element.getAttribute('data-url');
            if (window.isSecureContext && navigator.clipboard) {
                navigator.clipboard.writeText(currentLink);
                toogleTooltip(element)
            } else {
                unsecuredCopyToClipboard(currentLink, element);
            }
        });
    });

    const unsecuredCopyToClipboard = (text,el) => {
        const textArea = document.createElement("textarea");
        textArea.value=text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try{
            document.execCommand('copy');
            toogleTooltip(el)
        }
        catch(err){
            console.error('Unable to copy to clipboard',err)}
        document.body.removeChild(textArea)
    };

    function toogleTooltip(element){
        let copyInfo = element.querySelector('.share-button--copy')
        copyInfo.classList.add('share-button--copy-active')

        setTimeout(() => {
            copyInfo.classList.remove('share-button--copy-active')
        }, "3000");
    }
}

export function shareOfferMobile() {
    let element = document.getElementById('main-share-button');

    function isElementVisible() {
        let viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (viewportWidth < 1024) {
            let rect = element.getBoundingClientRect();
            let isVisible = (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );

            if (!isVisible) {
                document.querySelector('.single-offer__mobileFixed').classList.add('single-offer__mobileFixed-active')
            } else {
                document.querySelector('.single-offer__mobileFixed').classList.remove('single-offer__mobileFixed-active')
            }
        }
    }

    function checkElementVisibility() {
        window.addEventListener('scroll', isElementVisible);
    }

    window.addEventListener('load', checkElementVisibility);
    window.addEventListener('resize', checkElementVisibility);
}